module.exports = __webpack_public_path__ + "static/media/mulher_r2_c7.f6dde1af.jpg";